import { merge } from 'ramda';
import { PDF_SUCCESS, PDF_FAIL, PDF_REQUEST } from 'src/store/actions/pdfActions';

const initialState = {
  fetching: false,
  errors: []
};

const pdfReducer = (state = initialState, action) => {
  switch (action.type) {
    case PDF_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case PDF_SUCCESS:
      return merge(state, { fetching: false, errors: [] });
    case PDF_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    default:
      return state;
  }
};

export default pdfReducer;
